import { Route } from 'react-router-dom'
import Cotizaciones from '../pages/reportes/Cotizaciones'
import Contratos from '../pages/reportes/Contratos'
import ProtectedRoute from '../components/ProtectedRoute'


const ReportesRoutes = () => (
  <>
    <Route path="/reportes" >
      <Route
        path="reporte-cotizaciones"
        element={
          <ProtectedRoute requiredModule="maestros">
            <Cotizaciones />
          </ProtectedRoute>
        }
      />
      <Route
        path="reporte-contratos"
        element={
          <ProtectedRoute requiredModule="maestros">
            <Contratos />
          </ProtectedRoute>
        }
      />
      {/* Puedes agregar más rutas de tablas maestras aquí */}
    </Route>
  </>
)

export default ReportesRoutes
